// Libraries
import React, { useEffect, useState, useRef } from 'react';
import { PropTypes } from 'prop-types';

// Utilities
import { truncateString } from 'common/utils/helpers';

// Component
import { Text } from 'recharts';

const YAxisAutoScaleLabel = (props) => {
  const { x, y, parentWidth, truncate, payload } = props;
  const gRef = useRef(null);
  const [size, setSize] = useState(1);

  const value = truncate ? truncateString(payload.value, truncate) : payload.value;

  useEffect(() => {
    if (gRef && gRef.current) {
      if (gRef.current.getBoundingClientRect().width > parentWidth) {
        setSize((parentWidth - 10) / gRef.current.getBoundingClientRect().width);
      }
    }
  });

  return (
    <g transform={`translate(${x},${y})`} ref={gRef}>
      <Text x={0} y={0} textAnchor="end" fill="#666" fontSize={`${size}em`}>
        {value}
      </Text>
    </g>
  );
};

YAxisAutoScaleLabel.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  parentWidth: PropTypes.number,
  truncate: PropTypes.number,
  payload: PropTypes.shape({
    value: PropTypes.string,
  }),
};

YAxisAutoScaleLabel.defaultProps = {
  x: 0,
  y: 0,
  parentWidth: 0,
  truncate: 0,
  payload: {
    value: '',
  },
};

export default YAxisAutoScaleLabel;
